const columns = [
    {
        title: '',
        field: 'name'
    }
];

export default columns;
